<template>
  <div class="btn-group">
    <button
      class="request-list__ellipsis-button-group"
      data-bs-toggle="dropdown"
      :title="$localize('MoreOptionsTooltip')"
      data-test="more-options-button"
    >
      <i
        class="fa-solid fa-ellipsis-v"
        aria-hidden="true"
      />
      <span class="visually-hidden">
        {{ $localize('MoreOptionsTooltip') }}
      </span>
    </button>
    <ul class="request-list__ellipsis-dropdown-menu dropdown-menu float-end">
      <li
        v-for="(action, index) in actions"
        :key="index"
        :data-test="action.dataTestAttribute"
      >
        <a
          href="#"
          class="request-list__ellipsis-dropdown-item dropdown-item"
          @click.prevent="onActionClick(action)"
        >
          <div class="request-list__ellipsis-dropdown-icon">
            <i
              class="px-1"
              :class="action.icon"
              aria-hidden="true"
            />
          </div>
          <span>
            {{ action.title }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
  import PaginatedListAction from '@/VueComponents/SharedComponents/PaginatedList/types/PaginatedListAction';

  const props = defineProps<{
    payload: any,
    actions: PaginatedListAction[]
  }>();

  const emit = defineEmits(['actionClicked']);

  function onActionClick(action: PaginatedListAction) {
    emit('actionClicked', action.eventName, props.payload);
  }
</script>